import { useMemo, useState } from "react"
import { Flex, Form, Select, Typography } from "antd"
import classNames from "classnames"

import { Currency } from "@src/app/CurrenciesCollection"
import { getCurrencyIcon } from "@src/shared/getCurrencyIcon"
import { getIcon } from "./getIcon"
import css from "./index.module.css"

const { Item } = Form

const { Paragraph } = Typography

type Props = {
  className?: string
  currencies: Currency[]
  hasDescription?: boolean
  network: string
  onChange: (value: string) => void
  symbol: string
}
export const ChooseCurrency = ({
  className,
  currencies,
  hasDescription = true,
  network,
  onChange,
  symbol,
}: Props) => {
  const [icon, setIcon] = useState<Pick<Currency, "network" | "symbol">>(
    getIcon(`${symbol} ${network}`),
  )

  const options = currencies.map((currency) => ({
    icon: getCurrencyIcon({
      network: currency.network,
      symbol: currency.symbol,
    }),
    label: `${currency.symbol_alias} ${currency.network}`,
    network: currency.network,
    symbol: currency.symbol,
    symbol_alias: currency.symbol_alias,
    value: `${currency.symbol} ${currency.network}`,
  }))

  const chosen = useMemo(() => {
    return options.find((option) => {
      return option.network === network && option.symbol === symbol
    })
  }, [network, options, symbol])

  const handleChange = ({ value }: { value: string }) => {
    const iconData = getIcon(value)

    setIcon(iconData)

    onChange(value)
  }

  return (
    <Form
      className={classNames(css.form, className)}
      id="GENERATED_ID_CHOOSECURRENCY_FORM_VOID_1"
      size="large"
    >
      <div className={css.currencyWrapper}>
        <Item
          className={css.item}
          initialValue={`${symbol} ${network}`}
          label="Select cryptocurrency"
          name="currency"
        >
          <Select
            id="GENERATED_ID_CHOOSECURRENCY_SELECT_VOID_1"
            labelInValue
            onChange={handleChange}
            optionRender={(option) => (
              <Flex align="center" gap={10}>
                <img
                  alt="currency icon"
                  className={css.icon}
                  src={option.data.icon}
                />
                <Typography.Text style={{ fontSize: 12 }}>
                  {option.data.symbol_alias} ({option.data.network})
                </Typography.Text>
              </Flex>
            )}
            options={options}
            popupClassName={css.select}
            size="large"
            style={{ fontSize: 14 }}
          ></Select>
        </Item>
      </div>
      {hasDescription && (
        <Paragraph
          className={css.addressDescription}
        >{`Your ${chosen?.symbol_alias ?? icon.symbol} Address`}</Paragraph>
      )}
    </Form>
  )
}
